import type { AskUserFormSchema } from "@/types/artifacts.ts";
import { linkTextOnly } from "./markdownPlainText.ts";

/**
 * What the chip calls a form. A lone question is its own best label; past that
 * the questions won't fit on one line, so the count stands in for them and the
 * form itself is one tap away.
 *
 * One line of the question's words: a question that links what it asks about
 * ("[Document: Q3 plan](https://…)") would otherwise show its syntax, and a
 * multi-line one would stop at its first line break on native.
 */
export const formChipTitle = (form: AskUserFormSchema): string =>
  form.fields.length === 1
    ? linkTextOnly(form.fields[0].question).replace(/\s+/g, " ").trim()
    : `${form.fields.length} questions`;
